import React, { useState, useRef, useEffect } from "react";
import styles from "./BannerContainer.module.scss";

const BannerContainer = (props) => {
  return (
    <div className={"section"}>
      <div className={styles.BannerContainer}>
        <a
          href={`https://flightclubdarts.com/flightclub10/your-stories`}
          target="_blank"
        >
          <img
            className={styles.BannerDesk}
            src="./img/FC_Your Stories_Wide Website Banner_V1.webp"
            alt="Flight Club Game 7"
          />
          <img
            className={styles.BannerMob}
            src="./img/FC_Your Stories_2-1 Website Banner.webp"
            alt="Flight Club Game 7"
          />
        </a>
      </div>
    </div>
  );
};

export default BannerContainer;
